/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ProxyControlledMock,
  ProxyControlledMockInterface,
} from "../ProxyControlledMock";

const _abi = [
  {
    inputs: [],
    name: "newImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation_",
        type: "address",
      },
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class ProxyControlledMock__factory {
  static readonly abi = _abi;
  static createInterface(): ProxyControlledMockInterface {
    return new Interface(_abi) as ProxyControlledMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ProxyControlledMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as ProxyControlledMock;
  }
}
